import { useState } from 'react';
import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material';
import SingleLineChart from '../components/Chart/SingleLineChart';
import { styled } from '@mui/material/styles';



const InClassStressChart = ({inclassData}) => {
    const lineWidth = [ 4, 4, 4, 4 ];
    const lineDash = [0, 0, 0, 0];
    const series2 = [];
    const [selected, setSelected] = useState('Overall');
    const handleSelection = (event, newSelection) => {
      setSelected(newSelection);
    };

    const SuiteToggleButton = styled(ToggleButton)({
      flex: 1,
      boxShadow: 'none',
      textTransform: 'none',
      color: '#406599',
      '&:hover': {
        backgroundColor: '#c6e5fb',
      },
      "&.Mui-selected, &.Mui-selected:hover": {
        color: "#406599",
        backgroundColor: '#9cd1f8'
      }
    });

    return (
        <>
            <Grid item xs={12} sx={{ minWidth: "1080px", marginBottom:'30px'}}>
                <ToggleButtonGroup
                  value={selected}
                  exclusive
                  onChange={handleSelection}
                  aria-label="select option"
                  sx={{ display: "flex", width: "100%"}}
                >
                  <SuiteToggleButton value="Overall" aria-label="Overall">
                    Overall
                  </SuiteToggleButton>
                  <SuiteToggleButton value="PSS" aria-label="app's PSS">
                    App PSS
                  </SuiteToggleButton>
                </ToggleButtonGroup>
            </Grid>
            { selected === 'Overall' && (<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.used_RAM_chart_series} decimal={0} title='System Kerenl RAM Usage' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.sunreclaim_chart_series} decimal={0} title='SUnreclaim Memory' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.pss_chart_series} decimal={0} title='Apps Memory Used by a process' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.pid_chart_series} decimal={0} title='Apps PID monitor by a process' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
            </Grid>)}
            { selected === 'PSS' && (<Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.pss_home_series} decimal={0} title='PSS Usage for Home app' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.pss_raccoon_chart_series} decimal={0} title='PSS Usage for Raccoon' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.pss_dm_chart_series} decimal={0} title='PSS Usage for DM' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
              <Grid item xs={6}>
                <SingleLineChart isLoading={true} categories={inclassData.count} series={inclassData.pss_ota_chart_series} decimal={0} title='PSS Usage for OTA Service' lineWidth={lineWidth} lineDash={lineDash} title2='' series2={series2}/>
              </Grid>
            </Grid>)}
        </>
    );
};

export default InClassStressChart;
